module.exports = __webpack_public_path__ + "4615ecec2fcd71c628addd8ffa08f76e.svg";